export const EVENT_CHANNEL = 'peopleTeams';
